var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      ref: "root",
      staticClass: "fm-select",
      class: {
        "fm-select--open": _vm.open,
        "fm-select--disabled": _vm.disabled,
      },
    },
    [
      _c(
        "select",
        {
          ref: "native",
          staticClass: "fm-select__native",
          attrs: {
            disabled: _vm.disabled,
            tabindex: "-1",
            "aria-hidden": "true",
          },
        },
        [
          _c("option", { attrs: { value: "" } }),
          _vm._v(" "),
          _vm._l(_vm.normalizedOptions, function (opt) {
            return _c("option", {
              key: opt.value,
              domProps: { value: opt.value, textContent: _vm._s(opt.label) },
            })
          }),
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "fm-select__trigger form-control",
          class: { "fm-select__trigger--empty": !_vm.hasValue },
          attrs: {
            tabindex: _vm.disabled ? -1 : 0,
            role: "combobox",
            "aria-haspopup": "listbox",
            "aria-expanded": _vm.open,
            "aria-controls": _vm.listboxId,
            "aria-activedescendant":
              _vm.open && _vm.highlightedIndex >= 0
                ? _vm.optionId(_vm.highlightedIndex)
                : null,
          },
          on: {
            click: function ($event) {
              !_vm.disabled && _vm.toggle()
            },
            keydown: [
              function ($event) {
                if (
                  !$event.type.indexOf("key") &&
                  _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                )
                  return null
                $event.preventDefault()
                !_vm.disabled && _vm.onEnter()
              },
              function ($event) {
                if (
                  !$event.type.indexOf("key") &&
                  _vm._k($event.keyCode, "space", 32, $event.key, [
                    " ",
                    "Spacebar",
                  ])
                )
                  return null
                $event.preventDefault()
                !_vm.disabled && _vm.onEnter()
              },
              function ($event) {
                if (
                  !$event.type.indexOf("key") &&
                  _vm._k($event.keyCode, "down", 40, $event.key, [
                    "Down",
                    "ArrowDown",
                  ])
                )
                  return null
                $event.preventDefault()
                !_vm.disabled && _vm.onArrow(1)
              },
              function ($event) {
                if (
                  !$event.type.indexOf("key") &&
                  _vm._k($event.keyCode, "up", 38, $event.key, [
                    "Up",
                    "ArrowUp",
                  ])
                )
                  return null
                $event.preventDefault()
                !_vm.disabled && _vm.onArrow(-1)
              },
              function ($event) {
                if (
                  !$event.type.indexOf("key") &&
                  _vm._k(
                    $event.keyCode,
                    "escape",
                    undefined,
                    $event.key,
                    undefined
                  )
                )
                  return null
                return _vm.close.apply(null, arguments)
              },
              function ($event) {
                if (
                  !$event.type.indexOf("key") &&
                  _vm._k($event.keyCode, "tab", 9, $event.key, "Tab")
                )
                  return null
                return _vm.close.apply(null, arguments)
              },
            ],
          },
        },
        [
          _vm.currentIcon
            ? _c("span", {
                staticClass: "fm-select__sel-icon",
                domProps: { innerHTML: _vm._s(_vm.currentIcon) },
              })
            : _vm._e(),
          _vm._v(" "),
          _c("span", { staticClass: "fm-select__sel-text" }, [
            _vm._v(_vm._s(_vm.currentLabel)),
          ]),
          _vm._v(" "),
          _c(
            "svg",
            {
              staticClass: "fm-select__chevron",
              class: { "fm-select__chevron--up": _vm.open },
              attrs: {
                width: "11",
                height: "7",
                viewBox: "0 0 11 7",
                fill: "none",
                "aria-hidden": "true",
              },
            },
            [
              _c("path", {
                attrs: {
                  d: "M1 1l4.5 5 4.5-5",
                  stroke: "currentColor",
                  "stroke-width": "1.6",
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round",
                },
              }),
            ]
          ),
        ]
      ),
      _vm._v(" "),
      _c("transition", { attrs: { name: "fm-drop" } }, [
        _vm.open
          ? _c(
              "div",
              {
                staticClass: "fm-select__menu",
                style: _vm.menuStyle,
                attrs: { id: _vm.listboxId, role: "listbox" },
              },
              _vm._l(_vm.normalizedOptions, function (opt, idx) {
                return _c(
                  "div",
                  {
                    key: opt.value,
                    staticClass: "fm-select__item",
                    class: {
                      "fm-select__item--active": _vm.isSelected(opt.value),
                      "fm-select__item--highlighted":
                        idx === _vm.highlightedIndex,
                    },
                    attrs: {
                      id: _vm.optionId(idx),
                      role: "option",
                      "aria-selected": _vm.isSelected(opt.value),
                    },
                    on: {
                      mouseenter: function ($event) {
                        _vm.highlightedIndex = idx
                      },
                      click: function ($event) {
                        return _vm.pick(opt.value)
                      },
                    },
                  },
                  [
                    _c("span", {
                      staticClass: "fm-select__item-icon",
                      domProps: { innerHTML: _vm._s(_vm.iconFor(opt.value)) },
                    }),
                    _vm._v(" "),
                    _c("span", { staticClass: "fm-select__item-label" }, [
                      _vm._v(_vm._s(opt.label)),
                    ]),
                    _vm._v(" "),
                    _vm.isSelected(opt.value)
                      ? _c(
                          "svg",
                          {
                            staticClass: "fm-select__item-check",
                            attrs: {
                              width: "13",
                              height: "10",
                              viewBox: "0 0 13 10",
                              fill: "none",
                              "aria-hidden": "true",
                            },
                          },
                          [
                            _c("path", {
                              attrs: {
                                d: "M1.5 5L5 8.5L11.5 1.5",
                                stroke: "#FFB000",
                                "stroke-width": "2",
                                "stroke-linecap": "round",
                                "stroke-linejoin": "round",
                              },
                            }),
                          ]
                        )
                      : _vm._e(),
                  ]
                )
              }),
              0
            )
          : _vm._e(),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }